module.exports = __webpack_public_path__ + "static/media/0401storyboards.000b7270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0401storyboards.jpg
// module id = 396
// module chunks = 0